import { CATEGORIES } from "@/lib/brand";

export default function CollectionCategories() {
  return (
    <section
      id="collections"
      data-testid="categories-section"
      className="py-24 md:py-32 bg-white"
    >
      <div className="mx-auto max-w-6xl px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6">
          <div className="max-w-2xl">
            <span className="inline-block text-xs tracking-[0.28em] uppercase font-semibold text-[#cb05a5]">
              Our Collections
            </span>
            <h2 className="mt-3 font-display font-black text-4xl sm:text-5xl text-slate-900 tracking-tight">
              A category for every kind of paper lover.
            </h2>
          </div>
          <p className="text-slate-600 max-w-md leading-relaxed">
            From the everyday notebook to the perfect gift set — here&apos;s
            what you&apos;ll find on our shelves.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {CATEGORIES.map((c) => (
            <article
              key={c.id}
              data-testid={`category-card-${c.id}`}
              className="group relative overflow-hidden rounded-3xl bg-white sb-hairline sb-shadow hover:sb-shadow-lg transition-all duration-500 hover:-translate-y-1"
            >
              <div className="relative aspect-[4/5] overflow-hidden">
                <img
                  src={c.image}
                  alt={c.title}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
                <div className="absolute top-4 left-4 w-11 h-11 rounded-2xl bg-white/95 backdrop-blur flex items-center justify-center text-xl shadow-md">
                  {c.icon}
                </div>
                <div className="absolute bottom-4 left-4 right-4 text-white">
                  <h3 className="font-display font-bold text-xl leading-tight">
                    {c.title}
                  </h3>
                  <p className="mt-1 text-sm text-white/85 leading-snug line-clamp-2">
                    {c.desc}
                  </p>
                </div>
              </div>
              <div className="p-5">
                <div className="flex flex-wrap gap-1.5">
                  {c.items.slice(0, 4).map((item) => (
                    <span
                      key={item}
                      className="px-2.5 py-1 rounded-full text-[11px] font-medium bg-slate-100 text-slate-700"
                    >
                      {item}
                    </span>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
